// This file is generated by pnpm icons:generate. Do not edit.

import {CircleQuestion_Stroke2_Corner2_Rounded as CanonicalCircleQuestion_Stroke2_Corner2_Rounded} from './Circle'

/** @deprecated Import CircleQuestion_Stroke2_Corner2_Rounded from `#/components/icons/Circle` instead. */
export const CircleQuestion_Stroke2_Corner2_Rounded =
  CanonicalCircleQuestion_Stroke2_Corner2_Rounded
